import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TIME_SLOTS, fmtTime } from "@/lib/eventMeta";

export const TimeSelect = ({
  value,
  onChange,
  testId,
  placeholder = "Select time",
  className = "rounded-sm h-11 text-base",
}) => {
  const slots = value && !TIME_SLOTS.includes(value) ? [value, ...TIME_SLOTS] : TIME_SLOTS;
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {slots.map((t) => (
          <SelectItem key={t} value={t} data-testid={`${testId}-option-${t}`}>
            {fmtTime(t)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
